"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateReceivableReport = void 0;
/* eslint-disable no-param-reassign */
const common_1 = require("@finley-technologies/common");
const updateReceivableReport = ({ receivableReport, receivable, }) => {
    var _a;
    receivableReport.assetValuation += receivable.valuationFields.valuation;
    receivableReport.totalPerformingExposure +=
        (_a = receivable.postProcessedFields.performingExposure) !== null && _a !== void 0 ? _a : 0;
    // Get current state of basic report
    const basicReport = receivableReport.basicReport;
    // *** Receivable calculations ***
    const totalReceivableExposure = basicReport.totalReceivableExposure +
        receivable.requiredIntermediateFields.exposure;
    const totalEligibleExposure = basicReport.totalEligibleExposure +
        receivable.eligibilityFields.eligibleExposure;
    const eligibleExposureLessConcentrationKickouts = basicReport.borrowingBaseAmountAssets +
        receivable.concentrationLimitFields
            .eligibleExposureLessConcentrationLimitKickouts;
    const borrowingBaseAmount = basicReport.maxReceivableAdvanceAmount +
        receivable.borrowingBaseFields.borrowingBaseAmount;
    // *** Aggregate calculations (uses results from above) ***
    const totalEligibilityKickout = totalReceivableExposure - totalEligibleExposure;
    const totalConcentrationKickout = totalEligibleExposure - eligibleExposureLessConcentrationKickouts;
    receivableReport.effectiveReceivableValuationRate = common_1.utils.divideByOrZero(receivableReport.assetValuation, totalReceivableExposure);
    receivableReport.effectiveReceivableAdvanceRate = common_1.utils.divideByOrZero(borrowingBaseAmount, totalReceivableExposure);
    receivableReport.weightedAverageReceivableAdvanceRate = common_1.utils.divideByOrZero(borrowingBaseAmount, eligibleExposureLessConcentrationKickouts);
    // Explicitly setting all properties in this format to avoid missing any properties with direct param reassignment on each line above
    receivableReport.basicReport = {
        id: basicReport.id,
        borrowingBaseAmountAssets: eligibleExposureLessConcentrationKickouts,
        maxReceivableAdvanceAmount: borrowingBaseAmount,
        totalConcentrationKickout,
        totalEligibilityKickout,
        totalEligibleExposure,
        totalReceivableExposure,
    };
};
exports.updateReceivableReport = updateReceivableReport;
//# sourceMappingURL=receivableReport.js.map